import Vue from 'vue'
import VueRouter from 'vue-router'
import PcIndex from '../views/pc_index'
import detail from '../views/detail'
import jxh from '../views/jxh'
import hph from '../views/hph'
// import chats from '../views/chats'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '',
  //   redirect: '/discovery'
  // },  
  //path设置如 /home 服务器找不到文件，需要配置伪静态
  {
    path: '/index',
    name: 'index',
    component: PcIndex
  },
  {
    path: '/detail/:id(\\d+)',
    name: 'detail',
    component: detail
  },
  {
    path: '/jxh',
    name: 'jxh',
    component: jxh,
    meta: {
      title: '嘉习会'
    }
  },
  {
    path: '/hph',
    name: 'hph',
    component: hph,
    meta: {
      title: '海聘会'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  base: '/20220804hundredschools'
  // base: '/'
})

const defaultTitle = '“千企百校•万名青年”2022年百所高校嘉兴行暨高校毕业生嘉兴实践活动启动仪式'
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle
  next()
})

export default router
